var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:_vm.classList},[_vm._t("default",function(){return [_vm._v("Footer")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }